import { PipeTransform, Pipe, NgModule } from '@angular/core';

@Pipe({ standalone: false, name: 'times' })
export class TimesPipe implements PipeTransform {
  transform(value: number): any {
    const iterable = <Iterable<any>>{};
    iterable[Symbol.iterator] = function* () {
      let n = 0;
      while (n < value) {
        yield ++n;
      }
    };
    console.log(iterable);
    return iterable;
  }
}
